import React from 'react';
import PropTypes from 'prop-types';

const Verified = ({
	fill = '#8b7dba',
	...props
}) => (
	<svg width="15" height="17" viewBox="0 0 15 17" fill={fill} {...props}>
		<path d="M9.82812 15.7939C9.23438 16.221 8.64583 16.5492 8.0625 16.7783C7.6875 16.945 7.3125 16.945 6.9375 16.7783C6.0625 16.4242 5.22396 15.8981 4.42188 15.2002C3.61979 14.5023 2.88542 13.6585 2.21875 12.6689C1.55208 11.6794 1.01562 10.5075 0.609375 9.15332C0.203125 7.79915 0 6.38249 0 4.90332C0 4.77832 0.015625 4.65853 0.046875 4.54395C0.078125 4.42936 0.119792 4.31999 0.171875 4.21582C0.223958 4.11165 0.286458 4.0179 0.359375 3.93457C0.432292 3.85124 0.515625 3.77311 0.609375 3.7002C0.703125 3.62728 0.8125 3.56999 0.9375 3.52832L6.9375 1.02832C7.10417 0.944987 7.29167 0.90332 7.5 0.90332C7.70833 0.90332 7.89583 0.944987 8.0625 1.02832L14.0625 3.52832C14.3542 3.63249 14.5833 3.80957 14.75 4.05957C14.9167 4.30957 15 4.59082 15 4.90332C15 6.21582 14.8438 7.47103 14.5312 8.66895C14.2188 9.86686 13.8229 10.8981 13.3438 11.7627C12.8646 12.6273 12.3073 13.4085 11.6719 14.1064C11.0365 14.8044 10.4219 15.3669 9.82812 15.7939ZM7.5 2.93457V14.8408C9.0625 14.07 10.3594 12.8408 11.3906 11.1533C12.4219 9.46582 12.9583 7.49707 13 5.24707L7.5 2.93457Z"/>
	</svg>
);

Verified.propTypes = {
	fill: PropTypes.string
};

export default Verified;
